const config = {
  API_KEY: "PJW9HiD3ogFtaksm3e4mWmgJTQeXsdPZ",
};

export default config;
